import { StringKey } from '../lang/index';
import { PageRoute } from '../types/page.types';

export const pageTitleTranslation: Record<PageRoute, StringKey> = {
  [PageRoute.HOME]: 'MY_COMPANIES',
  [PageRoute.PROFILE]: 'MY_PROFILE',
  [PageRoute.MY_COMPANIES]: 'MY_COMPANIES',
  [PageRoute.COMPANY_SETUP]: 'COMPANY_SETUP',
  [PageRoute.COMPANY_SETTINGS]: 'COMPANY_SETTINGS',
  [PageRoute.DASHBOARD]: 'DASHBOARD',
  [PageRoute.DATA_ROOM]: 'DATA_ROOM',
  [PageRoute.DATA_ROOM_ACTIVITY]: 'DATA_ROOM',
  [PageRoute.DATA_ROOM_ACTIVITY_DATA_ROOMS]: 'DATA_ROOM',
  [PageRoute.DATA_ROOM_ACTIVITY_FILES]: 'DATA_ROOM',
  [PageRoute.DATA_ROOM_ACTIVITY_ROOM]: 'DATA_ROOM',
  [PageRoute.DATA_ROOM_ACTIVITY_VISITOR]: 'DATA_ROOM',
  [PageRoute.DATA_ROOM_ACTIVITY_VISITORS]: 'DATA_ROOM',
  [PageRoute.DATA_ROOM_INVITE]: 'DATA_ROOM',
  [PageRoute.DATA_ROOM_WORKSPACES]: 'DATA_ROOM',
  [PageRoute.DIVIDENDS]: 'DIVIDENDS',
  [PageRoute.STAKEHOLDERS]: 'STAKEHOLDERS',
  [PageRoute.EVENTS]: 'EVENTS',
  [PageRoute.MY_HOLDINGS]: 'MY_HOLDINGS',
  [PageRoute.FORGOT_PASSWORD]: 'FORGOT_PASSWORD',
  [PageRoute.SHARE_CLASSES]: 'SHARE_CLASSES',
  [PageRoute.SHARED_CAP_TABLE]: 'CAP_TABLE',
  [PageRoute.POOL_PLANS_POOL]: 'POOL_PLANS_POOL',
  [PageRoute.POOL_PLANS_PLAN]: 'POOL_PLANS_PLAN',
  [PageRoute.POOL_PLANS]: 'POOL_PLANS',
  [PageRoute.CAP_TABLE]: 'CAP_TABLE',
  [PageRoute.SETTINGS]: 'SETTINGS',
  [PageRoute.ACCEPT_INVITATION]: 'ACCEPT_INVITATION',
  [PageRoute.AUTH_GOOGLE_CALLBACK]: 'SIGN_IN',
  [PageRoute.LOGIN]: 'LOGIN',
  [PageRoute.REGISTER]: 'REGISTER',
  [PageRoute.REGISTER_VERIFY]: 'REGISTER_VERIFY',
  [PageRoute.PASSWORD_RECOVERY]: 'PASSWORD_RECOVERY',
  [PageRoute.BILLING]: 'BILLING',
  [PageRoute.ERROR]: 'ERROR',
  [PageRoute.ALL_DONE]: 'ALL_DONE',
  [PageRoute.HANG_TIGHT]: 'HANG_TIGHT',
  [PageRoute.ONBOARDING]: 'ONBOARDING',
  [PageRoute.SAFES]: 'SAFES',
  [PageRoute.GUIDES]: 'MODIFY_GUIDE',
  [PageRoute.VAULT]: 'VAULT',
  [PageRoute.SCENARIO_MODELING]: 'SCENARIO_MODELING',
  [PageRoute.SCENARIO_DETAILS]: 'SCENARIO_MODELING',
  [PageRoute.WELCOME]: 'WELCOME',
  [PageRoute.PERKS]: 'PERKS',
  [PageRoute.LIBRARY]: 'LIBRARY',
  [PageRoute.DOCUMENTS]: 'DOCUMENTS',
  [PageRoute.DOCUMENTS_TEMPLATES]: 'TEMPLATES',
  [PageRoute.DOCUMENTS_SIGNATURES]: 'SIGNATURES',
  [PageRoute.SUBSCRIPTION_OFFER_ENTERPRISE]: 'WELCOME',
  [PageRoute.SUBSCRIPTION_OFFER_GROWTH]: 'WELCOME',
  [PageRoute.SUBSCRIPTION_OFFER_STARTUP]: 'WELCOME',
};
